export default __webpack_public_path__ + "static/media/shutterstock_1364416640.2de59aad.jpg";